import { MarketBasketDetailsDependencies } from '@/features/market-baskets/market-basket-details-dependencies';

const MarketBasketLayout = () => {
  return <MarketBasketDetailsDependencies/>;
};

export default MarketBasketLayout;
